import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
}
const TableHeaders = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: var(--background-primary);
  border-top: 0.5px solid var(--border-primary);
  border-radius: 8px 8px 0 0;
  border-left: 0.5px solid var(--border-primary);
  border-right: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  `)}
`;
const Left = styled.div`
  display: flex;
  ${mobile_xl(css`
    display: flex;
    width: 100%;
    overflow: scroll;
    white-space: nowrap;
    scrollbar-width: none;
  `)}
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  ${mobile_xl(css`
    width: 100%;
    justify-content: flex-end;
  `)}
`;
const Icon = styled.div`
  padding-right: 12px;
  width: 18px;
  height: 18px;
  border-right: 0.5px solid var(--border-secondary);
  cursor: pointer;
  .svg-icon {
    path {
      stroke: var(--text-primary);
    }
  }
`;

const TitleLast = styled.div`
  color: var(--brand-primary);
  ${Typography.body_md_medium}
  padding: 0 12px;
  text-decoration: none;
  height: 18px;
  ${mobile_xl(css`
    padding: 0 0 0 12px;
  `)}
`;
const AllButton = styled.button<Props>`
  ${Typography.body_md_medium}
  background-color: var(--background-primary);
  color: var(--text-secondary);
  padding: 6px 15px;
  border: 0.5px solid transparent;
  cursor: pointer;
  ${(props: Props) =>
    props.isActive &&
    css`
      ${Typography.body_md_medium}
      background-color: var(--background-primary);
      border: 0.5px solid var(--border-primary);
      box-shadow: var(--shadow-card);
      border-radius: 16px;
      padding: 6px 15px;
      color: var(--text-primary);
    `}
  ${mobile_xl(css`
    width: 100%;
  `)}
`;

export { TableHeaders, Left, Right, Icon, AllButton, TitleLast };
